module.exports = __webpack_public_path__ + "static/media/custom-slide-img2.4f8be857.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/custom-slide-img2.png
// module id = 1049
// module chunks = 0